import RouteTemplate from 'ember-route-template'
import { MathseedsPrimeDashboardStudentPage } from 'teacher-ui-client/components/page/reporting/mathseeds-prime/dashboard/student'

export default RouteTemplate(MathseedsPrimeDashboardStudentPage)
